import { useCustomizedUrl } from "@/hooks/useCustomizedUrl.ts";
import { useTranslations } from "@/hooks/useTranslations.ts";
import type { Hit as AlgoliaHit } from "algoliasearch";
import { Highlight } from "./Highlight.tsx";
import { RawHTMLWithFallback } from "./RawHTMLWithFallback.tsx";

export function Product({
	hit,
	postFixLink,
}: {
	hit: AlgoliaHit<ItemboxAttributes>;
	postFixLink: string;
}) {
	const tc = useTranslations();
	const customizedUrl = useCustomizedUrl();
	const itemLink = "/" + customizedUrl + hit?.itemLink;
	const showVariantButton = hit.hasVariants || hit.pConEnabled || hit.twoDConfiguratorEnabled;
	const variantButtonConfiguration = hit.pConEnabled || hit.twoDConfiguratorEnabled;
	const href =itemLink + "?search_query=" + postFixLink;
	return (
		<li key={`product-${hit.objectID}`} className="aa-item itembox" data-itemno={hit.itemNo} data-item-id={hit.itemId} id={`item_${hit.itemId}`}>
			<a href={href} title={hit.description} data-gtm-item={hit.itemId} className="itembox__main gtm-product-click">
				<div className="itembox__name">
					<span>
						<Highlight hit={hit} attribute="description" />
					</span>
				</div>
				<div className="itembox__variantsCount">
					{hit.numberOfVariants > 0 && (
						<>
							{hit.numberOfVariants} {hit.numberOfVariants === 1 ? tc.variant : tc.variants}
						</>
					)}
				</div>
				<div className="itembox__head">
					<div className="itembox__image">
						<img
							className="itembox__imageSrc"
							src={hit?.itemImage /*? hit?.image_link : hit?.itemImage*/}
							width="300"
							height="300"
							loading="lazy"
						/>
					</div>
				</div>
			</a>
			<RawHTMLWithFallback className="itembox__warningTooltip" html={hit.warningTooltip} />
			<div className="itembox__footer">
				<div className="itembox__content">
					<div className="itembox__badges ">
						<RawHTMLWithFallback className="campaignBadges" html={hit.campaigns} />
						<RawHTMLWithFallback className="promotions" html={hit.promotions} />
					</div>
					<RawHTMLWithFallback
						className="itembox__prices"
						html={hit.prices}
						fallback={
							<div className="prices loading">
								{hit.showFundamentalPrice && <div className={"basePrice loadSkeleton"}>Loading</div>}
								<div className={"fundamentalPrice loadSkeleton"}>Loading</div>
							</div>
						}
					/>
				</div>
				<div className="itembox__actions">
					<RawHTMLWithFallback
						html={hit.favoriteSign}
						fallback={
							<span className="actionIcon">
								<i className="icon icon-favorites" aria-hidden="true" />
							</span>
						}
					/>
					{showVariantButton ? (
						<RawHTMLWithFallback
							html={hit.variantButton}
							fallback={
								<>
									{variantButtonConfiguration ? (
										<a href={hit?.item_link ?? itemLink} className="buttonIcon buttonIcon--primary buttonIcon--iconLarge">
											<i className="icon icon-settings" aria-hidden="true" />
										</a>
									) : (
										<a href={hit?.item_link ?? itemLink} className="buttonIcon buttonIcon--outline">
											<i className="icon icon-arrow-right" aria-hidden="true" />
										</a>
									)}
								</>
							}
						/>
					) : (
						<form
							name={"form_" + hit.itemId}
							id={"form_" + hit.itemId}
							method="POST"
							className="js-updateItem"
							data-action="shop_add_item_to_basket_list"
						>
							<input type="hidden" name="item_qty" value="1" />
							<input type="hidden" name="item_id" value={hit.itemId} />
							<RawHTMLWithFallback
								className="algoliaOrderbuttonWrapper"
								html={hit.orderbutton}
								fallback={
									<div className="orderButtonWrapper" aria-hidden="true">
										<button type="submit" className="orderButton button buttonIcon--outline button--primary">
											<i className="icon icon-basket" aria-hidden={true}></i>
										</button>
									</div>
								}
							/>
						</form>
					)}
				</div>
			</div>
			<RawHTMLWithFallback className="itembox__addon" html={hit.inventorySign} />
		</li>
	);
}
